import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

/**
 * Card de painel com cabeçalho fixo e rolagem própria: a lista cresce dentro
 * do card, não na página. A altura vem de quem usa (grade com altura cheia no
 * desktop; `max-h-*` no celular).
 */
export function CartaoRolavel({
  titulo,
  icone: Icone,
  contagem,
  acoes,
  tom = "neutro",
  rodape,
  className,
  corpoClassName,
  children,
}: {
  titulo: string;
  icone?: LucideIcon;
  contagem?: number;
  acoes?: ReactNode;
  tom?: "neutro" | "alerta";
  rodape?: ReactNode;
  className?: string;
  corpoClassName?: string;
  children: ReactNode;
}) {
  return (
    <section
      aria-label={titulo}
      className={cn(
        "flex min-h-0 flex-col overflow-hidden rounded-xl border bg-white",
        tom === "alerta" ? "border-warning-500/30" : "border-neutral-200",
        className,
      )}
    >
      <header
        className={cn(
          "flex shrink-0 items-center gap-2 border-b px-4 py-3",
          tom === "alerta"
            ? "border-warning-500/20 bg-warning-100/60 text-warning-500"
            : "border-neutral-100 text-neutral-900",
        )}
      >
        {Icone && <Icone size={17} strokeWidth={1.75} className="shrink-0" />}
        <h2 className="min-w-0 flex-1 truncate text-base">
          {titulo}
          {contagem !== undefined && (
            <span
              className={cn(
                "ml-2 inline-flex min-w-6 justify-center rounded-full px-1.5 align-middle text-xs font-bold leading-5",
                tom === "alerta" ? "bg-warning-500 text-white" : "bg-neutral-100 text-neutral-600",
              )}
            >
              {contagem}
            </span>
          )}
        </h2>
        {acoes}
      </header>
      <div
        className={cn(
          "rolagem-fina min-h-0 flex-1 overflow-y-auto overscroll-contain",
          corpoClassName,
        )}
      >
        {children}
      </div>
      {rodape && (
        <footer className="shrink-0 border-t border-neutral-100 px-4 py-2.5">{rodape}</footer>
      )}
    </section>
  );
}
